<template>
    <div class="container mt-2">
    <!-- <br> -->
    <div class="card border-secondary mb-3" >
        <div class="card-header bg-info text-start"><b>แก้ไขสถานะใบสั่งตรวจ</b></div>
            <div class="card-body">
              <h3>Status</h3>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'LabCreate',
  components: {

  },
  data () {
    return {

    }
  },

  methods: {

  }
}
</script>

<style>

</style>
